import { createSlice } from '@reduxjs/toolkit';

const templateSlice = createSlice({
  name: 'templates',
  initialState: {
    templates: [],
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    addTemplate: (state, action) => {
      state.templates.push(action.payload); // Adds a new template to the list
    },
    removeTemplate: (state, action) => {
      state.templates = state.templates.filter(template => template._id !== action.payload); // Removes a template by id
    },
  },
});

export const { setLoading, setTemplates, setError, addTemplate, removeTemplate } = templateSlice.actions;

export default templateSlice.reducer;
